import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import type { TextProps } from "@similarweb/ui-components/foundations";
import { Text } from "@similarweb/ui-components/foundations";

export const StyledAccountRow = styled(Text).attrs<Partial<TextProps>>({
    fontVariant: "input2",
})`
    color: ${colorsPalettes.carbon["400"]};
`;

export const StyledAccountName = styled(Text).attrs<Partial<TextProps>>({
    fontVariant: "subtitle2",
})`
    margin-right: 4px;
    color: ${colorsPalettes.carbon["500"]};
`;
